module.exports = __webpack_public_path__ + "img/x-small-white.26a1b6fd.svg";